<template>
  <Modal name="DELETE_SERVICE_PROVIDER_MODAL" :title="title" actions>
    <template v-slot:body>
      <h-loading v-if="isLoadingBoard" />
      <div v-else>
        <p>{{ removeItemMessage }}</p>
        <v-card class="pa-5 grey lighten-4" outlined>
          <p class="mb-0">{{ name }}</p>
          <small class="grey--text">{{ document }}</small>
        </v-card>
      </div>
    </template>
    <template v-slot:actions>
      <div class="d-flex">
        <v-btn @click="() => closeAllModals()" :disabled="isLoading" class="grey--text mr-5" elevation="0" large text>
          {{ $t('forms.cancel') }}
        </v-btn>
        <v-btn @click="() => remove()" :loading="isLoading" color="primary" elevation="0" large>
          {{ $t('forms.delete') }}
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { formatDocument } from '../../../util/document'

import Modal from '../../../components/app/Modal'

export default {
  name: 'ServiceProviderDeleteModal',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['serviceProvider', 'isLoadingBoard']),
    ...mapMutations(['closeAllModals']),

    name() {
      return this.serviceProvider.name
    },

    document() {
      return formatDocument(this.serviceProvider.document)
    },

    removeItemMessage() {
      return this.$t('forms.removeItemMessage')
    }
  },

  methods: {
    ...mapActions(['removeServiceProvider']),

    remove() {
      this.isLoading = true
      this.removeServiceProvider(this.serviceProvider.id)
        .finally(() => this.isLoading = false)
    },
  },

  data() {
    return {
      title: this.$t('forms.delete'),
      isLoading: false,
    }
  }
}
</script>
